<template>
  <div class="contact-us-container">
    <div class="contact-header">
      <h1 class="contact-title">联系我们</h1>
      <p class="contact-subtitle">我会竭诚为您服务，有问题可以拨打电话，或扫码咨询</p>
      <div class="header-divider"></div>
    </div>

    <div class="map-container">
      <div id="map" class="map"></div>
    </div>

    <div class="contact-info-section">
      <div class="info-content">
        <h2 class="org-name">山东省心理咨询行业协会</h2>
        
        <div class="info-item">
          <span class="info-label">电话：</span>
          <span class="info-value">0537-3616866</span>
        </div>
        
        <div class="info-item">
          <span class="info-label">邮箱：</span>
          <a href="mailto:sdsxlzxhyxh@163.com" class="info-link">sdsxlzxhyxh@163.com</a>
        </div>
        
        <div class="info-item">
          <span class="info-label">地址：</span>
          <span class="info-value">山东省济宁市建设南路45号济宁医学院任城校区3号楼</span>
        </div>
      </div>

      <div class="qrcode-section">
        <img src="/static/images/qrcode.jpg" alt="二维码" class="qrcode-image" />
        <p class="qrcode-text">扫码咨询</p>
      </div>
    </div>
  </div>
</template>

<script>
/* global AMap */
export default {
  name: 'ContactUs',
  data() {
    return {
      map: null,
      marker: null,
      amapKey: '0061180e5ee914fa88363400789dd3e5',
      address: '山东省济宁市建设南路45号济宁医学院任城校区3号楼',
      orgName: '山东省心理咨询行业协会'
    }
  },
  mounted() {
    // 等待 AMap 加载完成
    this.waitForAMap()
  },
  beforeUnmount() {
    if (this.map) {
      this.map.destroy()
    }
  },
  methods: {
    // 等待 AMap 加载完成
    waitForAMap() {
      if (typeof AMap !== 'undefined') {
        this.initMapWithGeocoding()
      } else {
        // 如果 AMap 还未加载，等待一段时间后重试
        setTimeout(() => {
          this.waitForAMap()
        }, 100)
      }
    },

    // 使用地理编码API获取坐标并初始化地图
    async initMapWithGeocoding() {
      try {
        const location = await this.getLocationByAddress(this.address)
        
        if (location) {
          this.initMap(location)
        } else {
          // 如果地理编码失败，使用默认坐标
          console.warn('地理编码失败，使用默认坐标')
          this.initMap([116.587245, 35.415393])
        }
      } catch (error) {
        console.error('初始化地图失败:', error)
        // 使用默认坐标
        this.initMap([116.587245, 35.415393])
      }
    },

    // 地理编码：将地址转换为经纬度
    async getLocationByAddress(address) {
      try {
        const url = `https://restapi.amap.com/v3/geocode/geo?address=${encodeURIComponent(address)}&city=济宁&key=${this.amapKey}&output=JSON`
        
        const response = await fetch(url)
        const data = await response.json()
        
        if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
          const locationStr = data.geocodes[0].location
          const [lng, lat] = locationStr.split(',').map(Number)
          
          console.log('地理编码成功:', {
            address: address,
            location: [lng, lat],
            level: data.geocodes[0].level
          })
          
          return [lng, lat]
        } else {
          console.error('地理编码失败:', data.info)
          return null
        }
      } catch (error) {
        console.error('地理编码请求失败:', error)
        return null
      }
    },

    // 逆地理编码：将经纬度转换为地址（可选功能）
    async getAddressByLocation(lng, lat) {
      try {
        const url = `https://restapi.amap.com/v3/geocode/regeo?location=${lng},${lat}&key=${this.amapKey}&radius=1000&extensions=all&output=JSON`
        
        const response = await fetch(url)
        const data = await response.json()
        
        if (data.status === '1' && data.regeocode) {
          console.log('逆地理编码成功:', {
            formatted_address: data.regeocode.formatted_address,
            addressComponent: data.regeocode.addressComponent
          })
          
          return data.regeocode.formatted_address
        } else {
          console.error('逆地理编码失败:', data.info)
          return null
        }
      } catch (error) {
        console.error('逆地理编码请求失败:', error)
        return null
      }
    },

    // 初始化地图
    initMap(center) {
      this.map = new AMap.Map('map', {
        zoom: 16,
        center: center,
        resizeEnable: true
      })

      // 添加标记点
      this.marker = new AMap.Marker({
        position: center,
        title: this.orgName
      })
      
      this.map.add(this.marker)

      // 添加文本标注（显示地址信息）
      const text = new AMap.Text({
        text: this.orgName,
        position: center,
        offset: new AMap.Pixel(15, -60),
        style: {
          'background-color': '#ffffff',
          'border': '2px solid #189fd8',
          'border-radius': '6px',
          'padding': '10px 16px',
          'font-size': '15px',
          'font-weight': '600',
          'color': '#333',
          'box-shadow': '0 3px 10px rgba(0, 188, 212, 0.3)',
          'white-space': 'nowrap',
          'line-height': '1.4',
          'letter-spacing': '0.5px'
        }
      })
      
      this.map.add(text)

      // 添加信息窗体
      const infoWindow = new AMap.InfoWindow({
        content: `
          <div style="padding: 10px;">
            <h3 style="margin: 0 0 8px 0; font-size: 16px;">${this.orgName}</h3>
            <p style="margin: 0; font-size: 14px; color: #666;">${this.address}</p>
          </div>
        `,
        offset: new AMap.Pixel(0, -30)
      })

      // 点击标记显示信息窗体
      this.marker.on('click', () => {
        infoWindow.open(this.map, center)
      })

      // 使用插件方式加载控件（1.4.15 版本）
      AMap.plugin(['AMap.Scale'], () => {
        // 添加比例尺控件
        this.map.addControl(new AMap.Scale())
      })
    }
  }
}
</script>

<style scoped>
.contact-us-container {
  min-height: 100vh;
}

.contact-header {
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fafafa;
  padding: 50px 20px 40px;
}

.contact-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0 0 12px 0;
  text-align: left;
}

.contact-subtitle {
  font-size: 15px;
  color: #666;
  margin: 0 0 25px 0;
  line-height: 1.6;
}

.header-divider {
  height: 2px;
  background: #00bcd4;
  width: 100%;
  margin: 0;
}

.map-container {
  width: 100%;
  max-width: 1200px;
  height: 300px;
  margin: 30px auto;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}

.map {
  width: 100%;
  height: 100%;
}

.contact-info-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 20px 80px;
  background-color: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
  border-radius: 12px;
}

.info-content {
  flex: 1;
}

.org-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0 0 30px 0;
}

.info-item {
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.8;
}

.info-label {
  color: #666;
  font-weight: 500;
}

.info-value {
  color: #333;
}

.info-link {
  color: #189fd8;
  text-decoration: none;
  transition: color 0.3s;
}

.info-link:hover {
  color: #0097a7;
  text-decoration: underline;
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  background: #fff;
}

.qrcode-text {
  font-size: 14px;
  color: #666;
  margin: 0;
}

@media (max-width: 768px) {
  .contact-header {
    padding: 40px 15px 20px;
  }

  .contact-title {
    font-size: 28px;
  }

  .contact-subtitle {
    font-size: 14px;
  }

  .map-container {
    height: 300px;
  }

  .contact-info-section {
    flex-direction: column;
    padding: 30px 15px 50px;
    gap: 40px;
  }

  .org-name {
    font-size: 20px;
  }

  .info-item {
    font-size: 14px;
  }

  .qrcode-image {
    width: 120px;
    height: 120px;
  }
}
</style>
